export const testSettings: ITestNewGameSettings = {
  // customStartingFunds: { 0: 1000, 2: 1100 },
  challengeId: "win-as-rent-lord-without-houses",
  customPropertyOwnerships: [
    {
      propertyOrder: 1,
      playerOrder: 0,
    },

    {
      propertyOrder: 2,
      playerOrder: 0,
    },

    {
      propertyOrder: 4,
      playerOrder: 0,
    },

    {
      propertyOrder: 5,
      playerOrder: 0,
    },
    {
      propertyOrder: 7,
      playerOrder: 0,
    },

    {
      propertyOrder: 9,
      playerOrder: 0,
    },

    {
      propertyOrder: 11,
      playerOrder: 0,
    },
    {
      propertyOrder: 12,
      playerOrder: 0,
    },
    {
      propertyOrder: 13,
      playerOrder: 0,
    },

    {
      propertyOrder: 15,
      playerOrder: 0,
    },

    {
      propertyOrder: 17,
      playerOrder: 0,
    },

    {
      propertyOrder: 19,
      playerOrder: 0,
    },
    {
      propertyOrder: 20,
      playerOrder: 0,
    },
    {
      propertyOrder: 21,
      playerOrder: 0,
    },

    {
      propertyOrder: 23,
      playerOrder: 0,
    },

    {
      propertyOrder: 25,
      playerOrder: 0,
    },

    {
      propertyOrder: 27,
      playerOrder: 0,
    },
    {
      propertyOrder: 28,
      playerOrder: 0,
    },
    {
      propertyOrder: 29,
      playerOrder: 0,
    },

    {
      propertyOrder: 31,
      playerOrder: 0,
    },
  ],
  testPlayerPositions: [
    { playerOrder: 0, cellOrder: 22 },
    { playerOrder: 1, cellOrder: 10 },
    { playerOrder: 2, cellOrder: 5 },
    { playerOrder: 3, cellOrder: 33 },
  ],
  cards: {
    0: ["apply-property-tax", "apply-property-tax", "apply-property-tax", "apply-property-tax", "apply-property-tax"],
    // 0: [
    //   "get-two-more-cards",
    //   "get-two-more-cards",
    //   "get-two-more-cards",
    //   "perform-tax-audit",
    //   "apply-property-tax",
    //   "get-200-from-player",
    // ],
  },

  customStartingFunds: { 0: 1000, 1: -500, 2: -500, 3: -500 },

  mortgagedProperties: [],

  // testPlayerPositions: [{ playerOrder: 0, cellOrder: 0 }],
  testJailFreeCards: [
    {
      card: ["chance", "community-chest"],
      playerOrder: 0,
    },
  ],
  moneyOnTable: 1500,
}
